import { Button, CircularProgress } from "@mui/material";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import Select from 'react-select'
import AuthContext from "../../Context/AuthContext";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import { DashboardContext } from "../../Context/DashboardContext";
import Logo from '../../Assets/Images/logo.png'
import Stepper from "../../Components/Registration/Stepper";
import { color } from "chart.js/helpers";
import authDropdown from "../../Assets/Images/authdropdown.svg";
import TPLogo from '../../Assets/Images/TPLogo.png';
import CreatableSelect from 'react-select/creatable'
import cross from '../../Assets/Images/cross.svg'
import NewTPLogo from '../../Assets/Images/whiteLogo.png';



const CustomDropdownIndicator = () => {
  return (
    <div className="drop-down"  ><img src={authDropdown} alt="" /></div>

  );
};

const SignupDetails = () => {

  const location = useLocation();
  const locationState = location?.state
  const { orgId } = useParams()
  const inputRef = useRef(null)
  const [searchParams, setSearchParams] = useSearchParams(); 
  const navigate = useNavigate();
  const { id } = useParams();
  const [urlValid, setURLValid] = useState(null);
  const [url, setUrl] = useState("")
  const [urlCheck, setUrlCheck] = useState("empty");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const authCtx = useContext(AuthContext);
  const dashboardCtx = useContext(DashboardContext);
  const params = new URLSearchParams(location.search)
  const { isDetailsIncomplete } = location.state || {};

  const isReturningUser = params?.get("returning") === "true"

  let fromLoginPage;

  if ( locationState?.fromLoginPage ) {
    fromLoginPage = locationState?.fromLoginPage
  }

  const roles = [
    { value: 'coach/consultant', label: 'Coach/Consultant' },
    { value: 'counselor/therapist', label: 'Counselor/Therapist' },
    { value: 'leadership_director', label: 'Leadership Director' },
    { value: 'educator/trainer', label: 'Educator/Trainer' },
    { value: 'hr/people_development', label: 'HR/People Development' },
    { value: 'faith-based_leader', label: 'Faith-Based Leader' },
    { value: 'entrepreneur/business_owner', label: 'Entrepreneur/Business Owner' },
    { value: 'Other', label: 'Other' },
  ];



  const states = [
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' }
  ];

  const goals = [
    { value: 'goal1', label: 'Goal 1' },
    { value: 'goal2', label: 'Goal 2' },
    { value: 'goal3', label: 'Goal 3' },
  ];

  const denomiantions = [

    { value: 'Acst 29', label: 'Acst 29' },
    { value: 'American Baptist Churches', label: 'American Baptist Churches' },
    { value: 'Anglican', label: 'Anglican' },
    { value: 'Assemblies of God', label: 'Assemblies of God' },
    { value: 'Baptist', label: 'Baptist' },
    { value: 'Catholic', label: 'Catholic' },
    { value: 'Charismatic', label: 'Charismatic' },
    { value: 'Church of the Nazarene', label: 'Church of the Nazarene' },
    { value: 'Converge/Baptist General Conference', label: 'Converge/Baptist General Conference' },
    { value: 'Cooperative Baptist Fellowship', label: 'Cooperative Baptist Fellowship' },
    { value: 'Episcopalian', label: 'Episcopalian' },
    { value: 'Evangelical Free', label: 'Evangelical Free' },
    { value: 'Lutheran', label: 'Lutheran' },
    { value: 'Methodist', label: 'Methodist' },
    { value: 'Non-denominational', label: 'Non-denominational' },
    { value: 'Orthodox', label: 'Orthodox' },
    { value: 'Pentecostal', label: 'Pentecostal' },
    { value: 'Presbyterian', label: 'Presbyterian' },
    { value: 'Presbyterian Church of America', label: 'Presbyterian Church of America' },
    { value: 'Presbyterian Church, USA', label: 'Presbyterian Church, USA' },
    { value: 'Southern Baptist Convention', label: 'Southern Baptist Convention' },
    { value: 'Wesleyan', label: 'Wesleyan' },
    { value: 'Other', label: 'Other' },
  ];

  // const role = [
  //   { value: 'CEO', label: 'CEO' },
  //   { value: 'CFO', label: 'CFO' },
  //   { value: 'COO', label: 'COO' },
  //   { value: 'Director', label: 'Director' },
  //   { value: 'HR/People Manager', label: 'HR/People Manager' },
  //   { value: 'Administrator', label: 'Administrator' },
  //   { value: 'Team/Department Manager', label: 'Team/Department Manager' },
  //   { value: 'Service/Customer Service Manager', label: 'Service/Customer Service Manager' },
  //   { value: 'Project Manager', label: 'Project Manager' },
  //   { value: 'Supervisor', label: 'Supervisor' },
  //   { value: 'Marketing/Sales Consultant', label: 'Marketing/Sales Consultant' },
  //   { value: 'Accounting/Finance', label: 'Accounting/Finance' },
  //   { value: 'Operations Manager', label: 'Operations Manager' },
  //   { value: 'Logistics/Supply Chain Coordinator', label: 'Logistics/Supply Chain Coordinator' },
  //   { value: 'Executive Assistant', label: 'Executive Assistant' },
  //   { value: 'Nonprofit Leader', label: 'Nonprofit Leader' },
  //   { value: 'Pastor/Religious Leader', label: 'Pastor/Religious Leader' },
  //   { value: 'Athlete/Coach', label: 'Athlete/Coach' },
  //   { value: 'Entrepreneur/Small Business Owner', label: 'Entrepreneur/Small Business Owner' },
  //   { value: 'Personal Development Seeker', label: 'Personal Development Seeker' },
  //   { value: 'Consultant', label: 'Consultant' },
  //   { value: 'Educator/Trainer', label: 'Educator/Trainer' },
  //   { value: 'Creative Professional', label: 'Creative Professional' },
  //   { value: 'Health/Wellness Professional', label: 'Health/Wellness Professional' }
  // ];

  // const companies = [
  //   { value: 'Agriculture', label: 'Agriculture' },
  //   { value: 'Automotive', label: 'Automotive' },
  //   { value: 'Construction', label: 'Construction' },
  //   { value: 'Education/Training', label: 'Education/Training' },
  //   { value: 'Energy/Utilities', label: 'Energy/Utilities' },
  //   { value: 'Engineering', label: 'Engineering' },
  //   { value: 'Entertainment/Media', label: 'Entertainment/Media' },
  //   { value: 'Finance/Banking', label: 'Finance/Banking' },
  //   { value: 'Government/Public Services', label: 'Government/Public Services' },
  //   { value: 'Healthcare/Medical', label: 'Healthcare/Medical' },
  //   { value: 'Hospitality/Tourism', label: 'Hospitality/Tourism' },
  //   { value: 'Information Technology (IT)', label: 'Information Technology (IT)' },
  //   { value: 'Insurance', label: 'Insurance' },
  //   { value: 'Leadership Development/Consulting', label: 'Leadership Development/Consulting' },
  //   { value: 'Legal Services', label: 'Legal Services' },
  //   { value: 'Manufacturing/Production', label: 'Manufacturing/Production' },
  //   { value: 'Marketing/Advertising', label: 'Marketing/Advertising' },
  //   { value: 'Non-Profit/Charity/Churches', label: 'Non-Profit/Charity/Churches' },
  //   { value: 'Real Estate/Property', label: 'Real Estate/Property' },
  //   { value: 'Transportation/Logistics', label: 'Transportation/Logistics' }
  // ];  

  const role = [
    { value: 'Other', label: 'Other' },
    { value: 'Coach/Consultant', label: 'Coach/Consultant' },
    { value: 'Counselor/Therapist', label: 'Counselor/Therapist' },
    { value: 'Leadership Director', label: 'Leadership Director' },
    { value: 'Educator/Trainer', label: 'Educator/Trainer' },
    { value: 'HR/People Development', label: 'HR/People Development' },
    { value: 'Faith-Based Leader', label: 'Faith-Based Leader' },
    { value: 'Entrepreneur/Business Owner', label: 'Entrepreneur/Business Owner' }
  ];

  const sizeOfTeam = [
    { value: '1-5', label: '1-5' },
    { value: '6-10', label: '6-10' },
    { value: '11-20', label: '11-20' },
    { value: '21-50', label: '21-50' },
    { value: '51-100', label: '51-100' },
    { value: '101-500', label: '101-500' },
    { value: '500+', label: '500+' }
  ];

  const [formValues, setFormValues] = useState({
    phone: '',
    role: '',
    type_role: '',
    company: '',
    sizeOfTeam: ''
  });

  const [errors, setErrors] = useState({
    phoneError: '',
    roleError: '',
    companyError: '',
    sizeOfTeamError: ''
  });

  useEffect(() => {
    if (formValues.type_role?.length > 0 || formValues.role === "Other") {
      inputRef.current?.focus();
    }
  }, [formValues.type_role, formValues.role]);

   useEffect(() => {
  if (formValues.role === 'Other' && formValues.type_role.trim() === '') {
    setFormValues(prev => ({
      ...prev,
      role: ''
    }));
  }
}, [formValues.type_role]);


  // const validPhoneRegex = /^(\(\d+\)\s?)?(\d[\d\-]*(?:\s?\d[\d\-]*){9,})$/;
  // const validPhoneRegex = /^(\+)?[\d\s\-\(\)]*?\d{10,}[\d\s\-\(\)]*$/;
  // const validPhoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
  const validPhoneRegex = /^\d{10}$/;
  const validUrlRegex = /^(https?:\/\/[^\s]+)$/;
  const validNameRegex = /^[a-zA-Z\s'-]{2,}$/;
  const validZipCodeRegex = /^[a-zA-Z0-9\s'-]{6,}$/;

   const hasTenDigits = (str) => (str.match(/\d/g) || []).length === 10;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });

    if (name === 'firstname') {
      localStorage.setItem('firstname', value);
    }
    switch (name) {
      // case 'firstname':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: !validNameRegex.test(value) ? ' Please enter your first name' : '' }));
      //   break;
      // case 'lastname':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: !validNameRegex.test(value) ? 'Please enter your last name' : '' }));
      //   break;
      // case 'church':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: value.trim() === '' ? ' Please enter your church name' : value.length < 3 ? ' Please enter your church name' : '' }));
      //   break;
      // case 'city':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: !validZipCodeRegex.test(value) ? 'Please enter a valid ZIP code ' : '' }));
      //   break;
      case 'phone':
        const rawDigits = value.replace(/\D/g, '');
        console.log('rawDigits',rawDigits?.length)
        if (rawDigits.length > 10) return;
          const isValidFormat = /^\+?[0-9()\-]*$/.test(value);
          const isTenDigits = rawDigits.length === 10;
          const phoneError = !isValidFormat || !isTenDigits
            ? 'Please enter a valid phone number.'
            : '';
          // setFormValues(prev => ({ ...prev, phone: value }));
          // setErrors(prev => ({ ...prev, phoneError }));
          setFormValues({ ...formValues, [name]: formatPhoneNumber(value) });
          setErrors(prev => ({ ...prev, phoneError: !validPhoneRegex.test(extractNumber(value)) ? 'Please enter a valid phone number.' : '' }));
        break;
      case 'role':
        setErrors(prev => ({ ...prev, [`${name}Error`]: value.trim() === '' ? 'Please select/enter your role.' : '' }));
        break;
      // case 'denomination':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: value.trim() === '' ? 'Please select your denomination' : '' }));
      //   break;
      // case 'state':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: value.trim() === '' ? ' Please select your state' : '' }));
      //   break;
      // case 'staff':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: /^[1-9]\d*(\.\d+)?(-\d+)?$/.test(value) ? '' : 'Please only use numbers and ‘-’' }));
      //   break;
      // case 'goal':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: value.trim() === '' ? 'Please share your input' : '' }));
      //   break;
      // case 'congregants':
      //   setErrors(prev => ({ ...prev, [`${name}Error`]: /^[1-9]\d*(\.\d+)?(-\d+)?$/.test(value) ? '' : 'Please only use numbers and ‘-’' }));
      //   break;
      // case 'url':
      //   dashboardCtx.setConfigureUrl(value)
      //   setErrors(prev => ({ ...prev, urlError: !validUrlRegex.test(value) ? 'Please enter a valid URL' : '' }));
      //   break;
      // case 'gender':
      //   setErrors(prev => ({ ...prev, genderError: value.trim() === '' ? 'Please select your gender' : '' }));
      //   break;
      default:
        break;
    }
  };

  const formatPhoneNumber = (value) => {
    // Remove all non-numeric characters
    let cleaned = value.replace(/\D/g, "");

    // Apply formatting: (XXX) XXX-XXXX
    let formatted = "";
    if (cleaned.length > 6) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length > 3) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else if (cleaned.length > 0) {
      formatted = `(${cleaned}`;
    }

    return formatted;
  };

  const extractNumber = (number) => number.replace(/\D/g, "");

  const handleLogout = () => {
    authCtx.logout();
    navigate("/login");
  };

  const handleSelectChange = (name, value) => {
    const trimmedValue = value.trim();
    setFormValues({ ...formValues, [name]: trimmedValue });

    switch (name) {
      case 'role':
        setErrors(prev => ({
          ...prev,
          [`${name}Error`]: trimmedValue === '' ? 'Please select/enter your role.' : ''
        }));
        break;
      case 'sizeOfTeam':
        setErrors(prev => ({
          ...prev,
          [`${name}Error`]: trimmedValue === '' ? 'Please select the size of your team.' : ''
        }));
        break;
      case 'company':
        setErrors(prev => ({
          ...prev,
          [`${name}Error`]: trimmedValue === '' ? 'Please enter your company name.' : ''
        }));
        break;
      default:
        break;
    }
  };


  //check for any validation errors during form submission//
  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // if (!validNameRegex.test(formValues.firstname) || formValues.firstname.trim() === '') {
    //   newErrors.firstnameError = 'Please enter your first name';
    //   valid = false;
    // }
    // if (!validNameRegex.test(formValues.lastname) || formValues.lastname.trim() === '') {
    //   newErrors.lastnameError = 'Please enter your last name';
    //   valid = false;
    // }
    if ( formValues.phone.trim() === '' || !validPhoneRegex.test(extractNumber(formValues.phone)) ) {
      newErrors.phoneError = 'Please enter a valid phone number.';
      valid = false;
    }
    if (formValues.role.trim() === '') {
      newErrors.roleError = 'Please select/enter your role.';
      valid = false;
    }
    // if (formValues.gender.trim() === '') {
    //   newErrors.genderError = 'Please select your gender';
    //   valid = false;
    // }
    // if (formValues.church.trim() === '') {
    //   newErrors.churchError = 'Please enter your church name';
    //   valid = false;
    // }
    // if (formValues.denomination.trim() === '') {
    //   newErrors.denominationError = 'Please select your denomination';
    //   valid = false;
    // }
    // // console.log("formValues.city.trim() === '", formValues.city.trim() === '')
    // if (!validZipCodeRegex.test(formValues.city)) {
    //   newErrors.cityError = 'Please enter your valid ZIP code'
    //   valid = false;
    // }
    // if (formValues.state.trim() === '') {
    //   newErrors.stateError = 'Please select your state';
    //   valid = false;
    // }
    // if (formValues.staff === '') {
    //   newErrors.staffError = 'Please enter your staff size (approx.)';
    //   valid = false;
    // } else if (!(/^[1-9]\d*(\.\d+)?(-\d+)?$/.test(formValues.staff))) {
    //   newErrors.staffError = 'Please only use numbers and "-"';
    //   valid = false;
    // } else {
    //   newErrors.staffError = '';
    // }
    // if (formValues.congregants === '') {
    //   newErrors.congregantsError = 'Please enter your Sunday attendance (approx.)';
    //   valid = false;
    // } else if (!(/^[1-9]\d*(\.\d+)?(-\d+)?$/.test(formValues.staff))) {
    //   newErrors.congregantsError = 'Please only use numbers and "-"';
    //   valid = false;
    // } else {
    //   newErrors.congregantsError = '';
    // }
    // if (formValues.goal.trim() === '') {
    //   newErrors.goalError = 'Please share your input';
    //   valid = false;
    // }
    // if (!(validUrlRegex.test(`https://${url}.scatter.us`) && url !== '')) {
    //   newErrors.urlError = 'Please enter a valid URL';
    //   valid = false;
    // }
    const companyValue = formValues.company.trim();
    if (companyValue === '') {
      newErrors.companyError = 'Please enter your company name.';
      valid = false;
    } else if (!/^[A-Za-z0-9&.\-'\s]{2,100}$/.test(companyValue)) {
      newErrors.companyError = 'Please enter your company name.';
      valid = false;
    }

    if (formValues.sizeOfTeam.trim() === '') {
      newErrors.sizeOfTeamError = 'Please select the size of your team.';
      valid = false;
    }

    setErrors(newErrors);
    if (valid) {
      const staffValue = formValues.staff ? formValues.staff.toString() : '';
      const congregantsValue = formValues.congregants ? formValues.congregants.toString() : '';
      const partsstaff = staffValue.split('-');
      const partscongregants = congregantsValue.split('-');
      const staffInt = parseInt(partsstaff[0], 10);
      const congregantsInt = parseInt(partscongregants[0], 10);
      setFormValues(prev => ({
        ...prev,
        congregants: congregantsInt,
        staff: staffInt
      }));
    }

    setIsLoading(false)
    return valid;
  };

  useEffect(() => {
    if (formValues.url !== '') {
      setURLValid("testing");
      setErrors(errors => ({ ...errors, urlError: '' }))
      setTimeout(() => {
        if (validUrlRegex.test(`https://${formValues.url}.scatter.us`) && formValues.url !== '') {
          setURLValid("valid");
        }
        else {
          setURLValid("invalid");
          setErrors(errors => ({ ...errors, urlError: 'Invalid URL format' }))
        }
      }, 2000);
    }
  }, [formValues.url])
  // const validateForm = () => {
  // 	return Object.values(errors).every(error => error === '') &&
  // 	Object.values(formValues).every(value => value.trim() !== '');
  // };
  // const signupDetails = (e) => {
  // 	e.preventDefault();
  // 	if (validateForm()) {
  // 	navigate('');
  // 	}
  // }
  const submitUserDetails = async (phone, role, company, sizeOfTeam) => {
    setIsLoading(true);
  
    const id = authCtx.orgId || localStorage.getItem("orgId");

  
    if (!id) {
      setIsLoading(false);
      return;
    }

  
    try {
      const userResponse = await fetch(
        `${process.env.REACT_APP_API_URI}/v4/organisation/user/${authCtx?.userId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone, role, companyName: company, sizeOfTeam}),
        }
      );
  
      if (!userResponse.ok) throw new Error("Failed to update user details");

      const orgResponse = await fetch(
        `${process.env.REACT_APP_API_URI}/v4/organisation/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({status: "active", orgName: company }),
        }
      );
  
      if (!orgResponse.ok) throw new Error("Failed to update organization details");
  
      const data = await orgResponse.json();
      return data;
  
    } catch (err) {
      console.error(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };
  

  const submitOrganizationDetails = (company, sizeOfTeam) => {
    const id = authCtx.orgId || localStorage.getItem('orgId') || null;
    if (id) {
      return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URI}/v4/organisation/details/${id}`, {
          method: 'PUT',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              "properties": [
                { "property": "companyName", "value": company },
                { "property": "sizeOfTeam", "value": sizeOfTeam },
              ]
            })
        })
          .then(response => response.json())
          .then(data => {
            resolve(data);
          })
          .catch((err) => {
            console.error("Failed to submit details, please try again", err);
            reject(err);
          });
      });
    }
    else {
      // console.log("Organization Id not found");
      return;
    }
  };

  const handleSubmit = async (event) => {
    setIsLoading(true)
    event.preventDefault();
    // console.log("Form submitted");
    if (validateForm()) {
      const response = await submitUserDetails(formValues.phone, formValues.role, formValues.company, formValues.sizeOfTeam);
      if (response?.status === "success") {
        const response = await submitOrganizationDetails(formValues.company, formValues.sizeOfTeam);
        authCtx.setConfigureUrl(url);
        if (response?.status === "success") {
          const toDashboard = searchParams.get('toDashboard') == 'true';
          // console.log("toDashboard",toDashboard)

          if ( toDashboard ) {
            navigate(`/dashboard`);
          }
          else {
            navigate(`/signup-payment/${orgId}`);
          }
        }
      }
    }
    setIsLoading(false)
  };

  const checkUrl = async (event) => {
    let urlValue = event.target.value;
    setUrl(urlValue);
    setUrlCheck("checking");
    fetch(`${process.env.REACT_APP_API_URI}/v4/organisation/urlCheck/${urlValue}`, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status == "success") {
          setIsFormValid(true);
          setUrlCheck("valid");
        } else {
          setIsFormValid(false);
          setUrlCheck("error");
        }
      })
      .catch((err) => {
        console.error("Failed to submit details, please try again", err);
      });
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: 50, minHeight: 50, width: 400, borderColor: state.isFocused ? '#5795B2' : base.borderColor, boxShadow: state.isFocused ? '0 0 0 1px #5795B2' : base.boxShadow,
      '&:hover': { borderColor: state.isFocused ? '#5795B2' : base.borderColor, },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '48px', padding: '0 15px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px', height: '48px',
    }),
    placeholder: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif', color: '#C7C7C7', fontSize: 18, lineHeight: '21.6px', fontWeight: 400,
    }),
    singleValue: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif', color: '#303030', fontSize: 18, lineHeight: '21.6px', fontWeight: 400,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    // dropdownIndicator: () => ({
    //   display: 'none',
    // }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '8px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: '10px',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? '#426B88'
        : state.isFocused
        ? '#DDEAF0'
        : 'white',
      color: state.isSelected ? 'white' : '#303030',
      fontFamily: 'Lato, sans-serif',
      fontSize: 16,
      cursor: 'pointer',
      ':active': {
        backgroundColor: state.isSelected
          ? '#426B88'
          : state.isFocused
          ? '#DDEAF0'
          : 'white',
        },
      }),
  };

  const handleFormChange = (e) => {
  const { name, value } = e.target;
  setFormValues(prev => ({
    ...prev,
    [name]: value
  }));
};


  const customStylesWithoutArrow = {
    ...customStyles,
    dropdownIndicator: () => ({
      display: 'none',
    }),
  };

  const showUrlState = () => {
    switch (urlCheck) {
      case "valid": return <span className="form-success">Url is available</span>
      case "checking": return <span className="form-checking">Checking...</span>
      case "error": return <span className="form-error">Sorry this url already exists... Please try another</span>
      default: return "";
    }
  }

  const checkUrlProgress = () => {
    switch (urlCheck) {
      case "valid": return <CheckCircleIcon style={{ color: "#7D8704" }} />;
      case "checking": return <RotateRightIcon className="icon-sync" />;
      case "error": return <CancelIcon style={{ color: "#d63f15" }} />;
      default: return "";
    }
  }

  const goToPayment = (e) => {
    e.preventDefault();
    navigate('/signup-payment');
  }

  console.log('fromLoginPage', fromLoginPage)
  console.log('locationState', locationState)
  console.log('isDetailsIncomplete', isDetailsIncomplete)

  return (
    <div className="container signup-details-container">
      <div className="inner-container">
      <div className="left">
        <img src={NewTPLogo} alt="Logo" style={{ width: "113", height: "129" , objectFit: "contain"}} />
        <h1>Welcome to the <br /> Quadrant Flow Portal  </h1>
      </div>
        <div className="right">
          <form className="form" onSubmit={(e) => handleSubmit(e)}>
            <h2 style={{ width: isDetailsIncomplete || isReturningUser ? "450px" : "400px" }}>
              {isDetailsIncomplete || isReturningUser ? "Complete account creation" : "Create your account"}
            </h2>
            {/* <h4>Add your personal details</h4> */}
            <Stepper steps={{ current: 2, total: 3 }} />
            <div className="input-box">
              <label htmlFor="phone">Phone<span className="asterisk-mark">*</span></label>
              <input type="tel" name="phone" id="phone" placeholder="e.g. (555) 123-4567" value={formValues?.phone} onChange={(e) => handleChange(e)} />
              {errors.phoneError && <span className="form-error">{errors.phoneError}</span>}
            </div>
            <div className="input-box">

              <label htmlFor="role">Role<span className="asterisk-mark">*</span></label>
              {formValues.type_role?.length > 0 || formValues.role === "Other" ? (
                <>
                  <div className='title-type-text'>
                    <input ref={inputRef} type="text" name="type_role" title="" className='client-input' autoComplete="off" placeholder='Start typing' value={formValues.type_role}
                      onChange={(e) =>
                        setFormValues({ ...formValues, type_role: e.target.value })
                      }
                      required
                    />
                    <div
                      className='close-btn-typed-text'
                      onClick={() =>
                        setFormValues({ ...formValues, type_role: "", role: "" })
                      }
                    >
                      <img src={cross} alt="cross" className='cross-image' />
                    </div>
                  </div>
                  {errors.roleError && (
                    <span className="form-error">{errors.roleError}</span>
                  )}
                </>
                ) : (
                <>
                  <Select name="role" id="role" placeholder="Select/type your role" options={roles} value={roles.find(option => option.value === formValues.role) || null} onChange={(selectedOption) => handleSelectChange('role', selectedOption ? selectedOption.value : '')} styles={customStyles}
                    components={{
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    isSearchable={true}
                  />
                  {errors.roleError && <span className="form-error">{errors.roleError}</span>}
                </>
                )
              }
            </div>
            <div className="input-box">
              <label htmlFor="company">Company<span className="asterisk-mark">*</span></label>
              {/* <Select type="text" id="company" placeholder="Type in the name of your company"  styles={customStylesWithoutArrow} /> */}
              <input type="text" id="company" placeholder="Type the name of your company" name="company" onChange={(e) => handleChange(e)} />
              {errors.companyError && <span className="form-error">{errors.companyError}</span>}
            </div>
            <div className="input-box" style={{ position: "relative" }}>
              <label htmlFor="teamSize">Team Size<span className="asterisk-mark">*</span></label>
              <Select options={sizeOfTeam} value={sizeOfTeam.find(el => el.value === formValues.sizeOfTeam)} onChange={(e) => handleSelectChange('sizeOfTeam', e.value)} placeholder="Select the size of your team" styles={customStyles} components={{ DropdownIndicator: CustomDropdownIndicator }} />
              {errors.sizeOfTeamError && <span className="form-error">{errors.sizeOfTeamError}</span>}
            </div>
            <button disabled={isLoading} type="submit" variant="contained" color="primary">
              {isLoading ? <CircularProgress color="inherit" size={24} /> : "Proceed to Payment"}
            </button>
            {/* <span className="link" onClick={handleLogout}>Logout</span> prod-remove : signup logout btn */}
          </form>

        </div>
      </div>

      {/* <h1>Get Your Church Started</h1>
      <div className="details-form personal-details-form">
        <h2>Personal Information</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-row">
            <div className={`input-box ${errors.firstnameError ? 'error' : ''}`}>
              <label htmlFor="firstname">First Name*</label>
              <input type="text" name="firstname" id="firstname" value={formValues.firstname} onChange={handleChange} required />
              {errors.firstnameError && <span className="form-error">{errors.firstnameError}</span>}
            </div>
            <div className={`input-box ${errors.lastnameError ? 'error' : ''}`}>
              <label htmlFor="lastname">Last Name*</label>
              <input type="text" name="lastname" id="lastname" value={formValues.lastname} onChange={(e) => handleChange(e)} required />
              {errors.lastnameError && <span className="form-error">{errors.lastnameError}</span>}
            </div>
          </div>
          <div className="input-row">
            <div className={`input-box ${errors.phoneError ? 'error' : ''}`}>
              <label htmlFor="phone">Phone Number*</label>
              <input type="tel" name="phone" id="phone" value={formValues.phone} onChange={(e) => handleChange(e)} required />
              {errors.phoneError && <span className="form-error">{errors.phoneError}</span>}
            </div>
            <div className={`input-box ${errors.roleError ? 'error' : ''}`}>
              <label htmlFor="role">Role*</label>
              <Select options={roles} sele={roles.find(el => el.value === formValues.role)} onChange={(e) => handleSelectChange("role", e.value)} required placeholder="" styles={customStyles} />
              {errors.roleError && <span className="form-error">{errors.roleError}</span>}
            </div>
          </div>
          <div className="input-row">
            <div className="check-box">
              <label>Gender*</label>
              <div className="options">
                <div className={`option ${formValues.gender === 'male' ? 'selected-option' : ''}`} onClick={() => handleChange({ target: { name: 'gender', value: 'male' } })}>Male</div>
                <div className={`option ${formValues.gender === 'female' ? 'selected-option' : ''}`} onClick={() => handleChange({ target: { name: 'gender', value: 'female' } })}>Female</div>
              </div>
              {errors.genderError && <span className="form-error">{errors.genderError}</span>}
            </div>
          </div>
        </form>
      </div>

      <div className="details-form church-details-form">
        <h2>Church Details</h2>
        <form onSubmit={handleSubmit}>
          <div className={`input-box ${errors.churchError ? 'error' : ''} full-width-box`}>
            <label htmlFor="church">Church Name*</label>
            <input type="text" name="church" id="church" value={formValues.church} onChange={(e) => handleChange(e)} required />
            {errors.churchError && <span className="form-error">{errors.churchError}</span>}
          </div>


          <div className="input-row">
            <div className={`input-box ${errors.denominationError ? 'error' : ''}`}>
              <label htmlFor="denomination">Denomination*</label>
              <Select options={denomiantions} sele={denomiantions.find(el => el.value === formValues.denomination)} onChange={(e) => handleSelectChange("denomination", e.value)} placeholder="" required styles={customStyles} />
              {errors.denominationError && <span className="form-error">{errors.denominationError}</span>}
            </div>
            <div className={`input-box ${errors.cityError ? 'error' : ''}`}>
              <label htmlFor="city">ZIP CODE*</label>
              <input type="text" name="city" id="city" value={formValues.city} onChange={(e) => handleChange(e)} required />
              {errors.cityError && <span className="form-error">{errors.cityError}</span>}
            </div>
          </div>

          <div className="input-row">
            <div className={`input-box ${errors.staffError ? 'error' : ''}`}>
              <label htmlFor="staff">STAFF SIZE*</label>
              <input type="text" name="staff" id="staff" value={formValues.staff} onChange={(e) => handleChange(e)} required />
              {errors.staffError && <span className="form-error">{errors.staffError}</span>}
            </div>
            <div className={`input-box ${errors.congregantsError ? 'error' : ''}`}>
              <label htmlFor="congregants">SUNDAY ATTENDANCE*</label>
              <input type="text" name="congregants" id="congregants" value={formValues.congregants} onChange={(e) => handleChange(e)} required />
              {errors.congregantsError && <span className="form-error">{errors.congregantsError}</span>}
            </div>
          </div>
          <div className={`input-box ${errors.goalError ? 'error' : ''} full-width-box`}>
            <label htmlFor="goal">PRIMARY USE FOR SCATTER*</label>
            <input type="text" name="goal" id="goal" value={formValues.goal} onChange={(e) => handleChange(e)} required />
            {errors.goalError && <span className="form-error">{errors.goalError}</span>}
          </div>
          <div className={`input-box ${errors.urlError ? 'error' : ''} full-width-box`}>
            <label htmlFor="url">Configure URL*</label>
            <div className={`url-box ${errors.urlError ? 'error' : ''}`}>
              <div className="pre-link">https://</div>
              <div className="relative">
                <div className="icon">{checkUrlProgress()}</div>
                <input type="url" name="url" id="url" value={url} onChange={(e) => checkUrl(e)} required />
              </div>
              <div className="pre-link">.scatter.us</div>
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{showUrlState()}
          </div>
        </form>
      </div>
      <Button onClick={(e) => handleSubmit(e)} disabled={!isFormValid} type="submit" variant="contained" color="primary">CLICK TO CONTINUE</Button> */}
    </div>
  );

};

export default SignupDetails;
